import React, { useState, useEffect, useRef } from "react";
import { IconButton, Menu, MenuItem, Grid, Box } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate, useLocation } from "react-router-dom";
import LOGO from "../../resources/icons/logo.png";
import "./index.scss";
import { clearOfflineData, getOfflineData } from "../../utils/offline-services";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MobileNavbar from "./mobile-nav";
import { getNavigationTabs } from "./config";
import { USER_ROLES } from "../../utils/constants";

function CustomNavigationMenu() {
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [showSubMenu, setShowSubMenu] = useState({});
  const [tabsList, setTabsList] = useState([]);
  const [activeTab, setActiveTab] = useState("/");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const menuDivisions = 11 / (tabsList?.length || 1);
  const menuRef = useRef();

  // Toggle submenu visibility
  const handleMenuClick = (tabId) => {
    if (!showSubMenu[tabId]) {
      setShowSubMenu((prev) => {
        const updated = { ...prev, [tabId]: !prev[tabId] };
        return Object.keys(updated).reduce((acc, id) => {
          acc[id] = id === `${tabId}` ? updated[id] : false; // Close other menus
          return acc;
        }, {});
      });
    }
  };

  // Close submenus on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowSubMenu({});
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const logoutHandler = () => {
    clearOfflineData("user");
    clearOfflineData("tokens");
    sessionStorage.clear();
    navigate("/");
  };

  const redirectionHandler = (url) => {
    if (url) {
      navigate(url);
      setActiveTab(url);
      setShowSubMenu({});
    }
  };

  const isActive = (tab) => {
    return (
      activeTab === tab.url ||
      (tab.children && tab.children.some((child) => isActive(child)))
    );
  };
  const logoClickRedirection = () => {
    const { role } = getOfflineData("user");
    if (role === USER_ROLES.OEM) {
      navigate("/oem");
    } else {
      navigate("/admin/engine-replacement-trend");
    }
  };
  useEffect(() => {
    setActiveTab(pathname);
  }, [pathname]);

  useEffect(() => {
    const tabs = getNavigationTabs();
    setTabsList(tabs);
  }, []);

  return (
    <div ref={menuRef}>
      <Box className="top-nav-con si-hide-mobile">
        <Grid
          container
          sx={{ height: "100%", justifyContent: "space-between" }}
          className="navigation-con"
        >
          <Grid
            item
            md={0.5}
            display="flex"
            alignItems="center"
            onClick={logoClickRedirection}
          >
            <img src={LOGO} alt="LOGO" className="logo" />
          </Grid>
          {tabsList?.map((tab, i) => {
            const active = isActive(tab);
            return (
              <Grid
                md={menuDivisions}
                item
                className={`single-tab ${active ? "active-tab" : ""}`}
                onClick={() =>
                  tab.children && !tab.url
                    ? handleMenuClick(tab.id)
                    : redirectionHandler(tab.url)
                }
                key={tab.id}
              >
                <div className="w-100">
                  <div className="tab-con">
                    <div className="tab-label-con">
                      <img src={tab?.icon} alt={tab.name} />
                      <p className={`${active ? "active-text" : "label"}`}>
                        {tab.name}
                      </p>
                      {tab.children &&
                        !tab.children.every((child) => child.disabled) && (
                          <KeyboardArrowDownIcon
                            sx={{ ml: 2 }}
                            fontSize="small"
                          />
                        )}
                    </div>
                  </div>
                  {tab.children && showSubMenu[tab.id] && (
                    <div className="sub-menu-con visible">
                      {tab.children
                        // .filter((child) => !child.disabled)
                        .map((child) => {
                          if (!child.disabled) {
                            return (
                              <div
                                key={child.id}
                                className={`sub-menu-link ${
                                  isActive(child) ? "active-submenu" : ""
                                }`}
                                onClick={() => redirectionHandler(child.url)}
                              >
                                <span>{child.name}</span>
                              </div>
                            );
                          }
                        })}
                    </div>
                  )}
                </div>
              </Grid>
            );
          })}
          <Grid item md={0.5} display="flex" justifyContent="flex-end">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <AccountCircleIcon fontSize="large" />
            </IconButton>
            <Menu
              anchorEl={anchorElUser}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={logoutHandler}>Logout</MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Box>
      <Box className="si-hide-web" sx={{ width: "100%", background: "white" }}>
        <MobileNavbar
          logoutHandler={logoutHandler}
          navigate={navigate}
          anchorElUser={anchorElUser}
          setAnchorElUser={setAnchorElUser}
          logo={LOGO}
        />
      </Box>
    </div>
  );
}

export default CustomNavigationMenu;
